import { faStar, faCircle, faCopyright, faClock } from '@fortawesome/free-regular-svg-icons';

export default [faStar, faCircle, faCopyright, faClock];
